"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollableContainer = void 0;

var react_1 = __importDefault(require("react"));

function ScrollableContainer(props) {
  return react_1.default.createElement("div", Object.assign({}, props, {
    style: Object.assign({
      overflow: 'auto'
    }, props.style)
  }));
}

exports.ScrollableContainer = ScrollableContainer;